// Email Templates for various workflows
// This utility provides pre-formatted email bodies for different document request scenarios

export const emailTemplates = {
  // --- 1. REQUEST DETAILS TEMPLATES ---

  corporateRequestDetails: {
    subject: 'Client Return - Required Documents',
    bodyTemplate: (uploadLink) => `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.6; max-width: 600px;">
        <p>Thank you for entrusting Magizhini Technology Services Inc. with your client tax filing.</p>
        <p>To prepare your tax return, we will need the following:</p>
        <p><strong>📑 Financial Documents:</strong><br>
        1. Financial Statements (Balance Sheet & Income Statement)<br>
        2. General Ledger<br>
        3. Bank Statements & Reconciliations<br>
        4. Invoices & Receipts<br>
        5. T4 and T4A Slips for Employees<br>
        6. T5 Slips (if applicable)<br>
        7. Previous Year's Tax Return<br>
        8. Corporate Registration Documents</p>

        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width: 400px; border: 1px solid #e1e1e1; border-radius: 8px; font-family: Arial, sans-serif; margin-top: 20px; margin-bottom: 20px;">
          <tr>
            <td>
              <a href="${uploadLink}" style="text-decoration: none; color: inherit; display: block;">
                <div style="padding: 15px; background-color: #f9f9f9; border-bottom-left-radius: 8px; border-bottom-right-radius: 8px;">
                  <h3 style="margin: 0 0 5px 0; font-size: 16px; color: #333333;">📤 Secure Document Upload</h3>
                  <p style="margin: 0; font-size: 14px; color: #666666;">Click here to securely upload your documents to Orientalbiz.</p>
                </div>
              </a>
            </td>
          </tr>
        </table>
        <p>Or contact us at: <a href="mailto:magizhinitech@gmail.com" style="color: #0056b3; text-decoration: none;">magizhinitech@gmail.com</a></p>
        <p>We look forward to assisting you.<br><br>
        Best regards,<br>
        <strong>Client Support Team</strong><br>
        Magizhini Technology Services Inc.<br>
        📧 <a href="mailto:magizhinitech@gmail.com" style="color: #0056b3; text-decoration: none;">magizhinitech@gmail.com</a><br>
        Tel: <a href="tel:+16476874226" style="color: #0056b3; text-decoration: none;">+1 (647) 687-4226</a></p>
    </div>`
  },



  sendInvoice: {
    subject: (invoiceNum) => `Invoice #${invoiceNum} from Magizhini Technology Services Inc.`,
    bodyTemplate: (invoiceNum, dueDate, totalAmount) => `<div style="background-color: #f9fafb; padding: 40px 20px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #374151; line-height: 1.6;">
          <div style="max-width: 550px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03); border: 1px solid #e5e7eb;">
              
              <!-- Header with Logo -->
              <div style="padding: 20px 30px; text-align: center; border-bottom: 1px solid #e5e7eb;">
                  <img src="https://magizhinitech.com/magizhinilogo.png" alt="Magizhini Technology Services Inc. Logo" style="height: 50px; width: auto;">
              </div>

              <!-- Content Body -->
              <div style="padding: 35px 30px;">
                  <p style="margin-top: 0; font-size: 16px; color: #111827;">Hello,</p>
                  <p style="font-size: 15px; color: #4b5563;">Thank you for partnering with Magizhini Technology Services Inc. for your software development, IT infrastructure, and managed staffing needs. Please find the summary of your invoice <strong>#${invoiceNum}</strong> below.</p>
                  
                  <!-- Summary Card Box -->
                  <div style="background-color: #f0f9ff; border-left: 4px solid #0284c7; padding: 20px; margin: 25px 0; border-radius: 0 6px 6px 0;">
                      <table style="width: 100%; border-collapse: collapse;">
                          <tr>
                              <td style="padding: 6px 0; font-size: 14px; color: #4b5563; font-weight: 600; width: 45%;">Invoice Number:</td>
                              <td style="padding: 6px 0; font-size: 14px; color: #111827; font-weight: 700;">#${invoiceNum}</td>
                          </tr>
                          <tr>
                              <td style="padding: 6px 0; font-size: 14px; color: #4b5563; font-weight: 600;">Total Amount Due:</td>
                              <td style="padding: 6px 0; font-size: 16px; color: #16a34a; font-weight: 700;">$${totalAmount} CAD</td>
                          </tr>
                          <tr>
                              <td style="padding: 6px 0; font-size: 14px; color: #4b5563; font-weight: 600;">Due Date:</td>
                              <td style="padding: 6px 0; font-size: 14px; color: #dc2626; font-weight: 700;">${dueDate}</td>
                          </tr>
                      </table>
                  </div>

                  <!-- Attachment Callout -->
                  <p style="font-size: 14px; color: #4b5563; margin-bottom: 25px;">
                      <strong>📎 Attached Document:</strong> An itemized PDF copy of your IT services invoice is attached to this email for your records.
                  </p>

                  <!-- Payment Instructions -->
                  <h3 style="font-size: 16px; color: #111827; margin-top: 30px; margin-bottom: 10px;">How to pay</h3>
                  <p style="font-size: 14px; color: #4b5563; margin-top: 0;">
                      We accept payments via <strong>Interac e-Transfer</strong>. Please send your payment to <a href="mailto:magizhinitech@gmail.com" style="color: #2563eb; text-decoration: none; font-weight: 500;">magizhinitech@gmail.com</a>. 
                      <br><br>
                      <em>(Auto-deposit is enabled, so no password is required. Please include your Invoice Number in the e-Transfer message).</em>
                  </p>
                  
                  <p style="font-size: 15px; font-weight: 500; color: #111827; margin-top: 30px; margin-bottom: 0;">We appreciate your business!</p>
              </div>

              <!-- Footer -->
              <div style="background-color: #f3f4f6; padding: 25px 30px; border-top: 1px solid #e5e7eb; font-size: 13px; color: #4b5563;">
                  <strong style="font-size: 15px; color: #111827; display: block; margin-bottom: 3px;">Magizhini Technology Services Inc.</strong>
                  <span style="display: block; margin-bottom: 12px; color: #6b7280;">IT Solutions, Software Development & Managed Staffing</span>
                  
                  <!-- Tightly Grouped Contact Info without Tables -->
                  <div style="line-height: 1.8; margin-bottom: 20px;">
                      <strong>Email:</strong> <a href="mailto:magizhinitech@gmail.com" style="color: #2563eb; text-decoration: none;">magizhinitech@gmail.com</a><br>
                      <strong>Phone:</strong> <a href="tel:+16476874226" style="color: #2563eb; text-decoration: none;">+1 (647) 687-4226</a>
                  </div>
                  
                  <!-- System Disclaimer -->
                  <p style="margin-top: 0; margin-bottom: 0; font-size: 11px; color: #9ca3af; line-height: 1.4; border-top: 1px solid #e5e7eb; padding-top: 15px;">
                      <em>This is an automated message containing your invoice details. If you have any questions regarding your bill or technical services, please contact us using the information above.</em>
                  </p>
              </div>

          </div>
      </div>`
  },

  corporateFilingConfirmation: {
    subject: 'Confirmation: Your Client Filing has been Submitted',
    bodyTemplate: (clientName, filingType) => `<div style="background-color: #f9fafb; padding: 40px 20px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; color: #374151; line-height: 1.6;">
          <div style="max-width: 550px; margin: 0 auto; background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03); border: 1px solid #e5e7eb;">
              
              <!-- Header Banner (Indigo for Corporate) -->
              <div style="background-color: #4f46e5; padding: 35px 30px; text-align: center;">
                  <!-- White Checkmark Circle -->
                  <div style="background-color: #ffffff; width: 48px; height: 48px; border-radius: 50%; display: inline-block; line-height: 48px; margin-bottom: 15px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                      <span style="color: #4f46e5; font-size: 24px; font-weight: bold;">✓</span>
                  </div>
                  <h2 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600; letter-spacing: 0.5px;">Client Filing Successful</h2>
              </div>

              <!-- Content Body -->
              <div style="padding: 35px 30px;">
                  <p style="margin-top: 0; font-size: 16px; color: #111827;">Dear ${clientName},</p>
                  <p style="font-size: 15px; color: #4b5563;">This email is to confirm that your <strong>${filingType}</strong> has been successfully transmitted to the Canada Revenue Agency (CRA).</p>
                  
                  <!-- Attachment Callout Box -->
                  <div style="background-color: #eef2ff; border-left: 4px solid #4338ca; padding: 15px 20px; margin: 25px 0; border-radius: 0 6px 6px 0;">
                      <p style="margin: 0; font-size: 14px; color: #3730a3;"><strong>📎 Attached Documentation</strong><br>
                      A copy of your submission and the official CRA confirmation receipt are attached. <strong>Please retain these documents</strong> for your corporate records.</p>
                  </div>

                  <!-- Next Steps -->
                  <h3 style="font-size: 16px; color: #111827; margin-top: 30px; margin-bottom: 10px;">Next Steps</h3>
                  <ul style="font-size: 14px; color: #4b5563; padding-left: 20px; margin-top: 0;">
                      <li style="margin-bottom: 8px;"><strong>Payments:</strong> If there is a balance owing associated with this filing, please ensure it is remitted to the CRA directly through your business bank account prior to the deadline to avoid penalties and interest.</li>
                      <li><strong>Record Keeping:</strong> The CRA requires businesses to keep all supporting documents and records for a minimum of 6 years.</li>
                  </ul>

                  <p style="font-size: 15px; font-weight: 500; color: #111827; margin-top: 30px; margin-bottom: 0;">Thank you for continuing to partner with us for your corporate accounting needs.</p>
              </div>

              <!-- Footer -->
              <div style="background-color: #f3f4f6; padding: 30px; border-top: 1px solid #e5e7eb; font-size: 13px; color: #4b5563;">
                  <strong style="font-size: 15px; color: #111827; display: block; margin-bottom: 5px;">Magizhini Technology Services Inc.</strong>
                  <span style="display: block; margin-bottom: 15px; color: #6b7280;">Professional Accounting & Tax Services</span>
                  
                  <table width="100%" cellpadding="0" cellspacing="0" style="margin-top: 10px;">
                      <tr>
                          <td style="padding-bottom: 8px;">
                              <strong>Email:</strong> <a href="mailto:magizhinitech@gmail.com" style="color: #2563eb; text-decoration: none;">magizhinitech@gmail.com</a>
                          </td>
                      </tr>
                      <tr>
                          <td>
                              <strong>Phone:</strong> <a href="tel:+16476874226" style="color: #2563eb; text-decoration: none;">+1 (647) 687-4226</a>
                          </td>
                      </tr>
                  </table>
                  
                  <!-- Privacy Disclaimer -->
                  <p style="margin-top: 25px; margin-bottom: 0; font-size: 11px; color: #9ca3af; line-height: 1.5;">
                      <em><strong>Confidentiality Notice:</strong> This email and any attachments are confidential and intended solely for the use of the individual or entity to whom they are addressed.</em>
                  </p>
              </div>

          </div>
      </div>`
  },
};
